import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './Skeleton.module.scss';
var Skeleton = function (_a) {
    var _b = _a.animation, animation = _b === void 0 ? 'wave' : _b, variant = _a.variant, _c = _a.width, width = _c === void 0 ? '100%' : _c, height = _a.height, id = _a.id, dataId = _a.dataId;
    return (_jsx("span", { id: id, style: {
            width: width,
            height: variant === 'circular' || !height ? width : height,
        }, className: "".concat(styles.Skeleton, " ").concat(styles[variant], " ").concat(animation ? styles[animation] : ''), "data-testid": dataId }));
};
Skeleton.propTypes = {
    variant: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    animation: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
};
export { Skeleton };
//# sourceMappingURL=Skeleton.js.map